module.exports = __webpack_public_path__ + "static/media/Camera.c1169c13.png";